<template>
  <div id="app" class="cursor-pointer" @click="visualizarDocumento">
    <v-card tile flat>
      <v-card-title
        class="primary--text font-weight-bold body-1  my-0 pt-3 pb-1"
      >
        <v-tooltip bottom>
          <template #activator="{ on }">
            <span v-on="on">{{ documento.tituloFormatado }}</span>
          </template>
          <span>Clique para Visualizar as informações da decisão</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <show-pdf-documento
          @click.native.stop
          :edoc="documento._source.documento_edoc"
          :textButton="`Acessar Decisão`"
          :textTitle="`Decisão ${documento._source.documento_numero_ano}`"
        />
        <show-pdf-boletim
          @click.native.stop
          :idarqcas="documento._source.boletim_idarqcas"
          :textButton="`Acessar Boletim`"
          :textTitle="`${documento._source.boletim_titulo}`"
        />
      </v-card-title>

      <v-card-subtitle
        v-if="documento._source.documento_numero_ano"
        class="primary--text  mb-0 pb-3"
      >
        Decisão
        <span class="primary--text mb-1 font-weight-bold">
          {{ documento._source.documento_numero_ano }}
        </span>
      </v-card-subtitle>

      <v-row
        no-gutters
        class="mx-3 mb-3 text-justify body-2 grey--text text--darken-1"
      >
        <span v-html="documento.descricaoFormatada"></span>
      </v-row>

      <v-dialog
        v-model="dialog"
        width="60%"
        hide-overlay
        scrollable
        transition="dialog-bottom-transition"
      >
        <v-card tile>
          <v-toolbar dark color="primary lighten-1" tile>
            <v-toolbar-title>
              BOLETIM DE JURISPRUDÊNCIA
              {{
                documento._source.boletim_classificacao_tematica.toUpperCase()
              }}
              N. {{ documento._source.boletim_numero_ano }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text dark @click="copyLink()">
                <v-icon class="mr-3">mdi-share-variant</v-icon>
                COMPARTILHAR LINK
              </v-btn>
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row class="pr-2 pt-2">
              <v-col cols="6" class="mx-2">
                <span class="font-weight-bold">Boletim</span>
                <div>
                  Boletim de Jurisprudência
                  {{ documento._source.boletim_classificacao_tematica }}
                  N. {{ documento._source.boletim_numero_ano }}
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Data da Publicação</span>
                <div>
                  {{
                    new Date(
                      documento._source.boletim_data_publicacao
                    ).toLocaleDateString("pt-BR")
                  }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="mx-2">
                <span class="font-weight-bold">Decisão</span>
                <div>
                  Processo {{ documento._source.processo_numero_ano }} - Decisão
                  {{ documento._source.documento_numero_ano }}
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Resultado da Votação</span>
                <div>
                  {{ documento._source.jurisprudencia_votacao }}
                </div>
              </v-col>
            </v-row>

            <v-row class="pr-2">
              <v-col cols="auto" class="mx-2">
                <div class="text-justify">
                  {{ documento._source.boletim_verbetacao }}
                </div>
              </v-col>
            </v-row>
            <v-row class="pr-2">
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Resumo</span>
                <div class="text-justify">
                  {{ documento._source.boletim_resumo }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import ShowPdfBoletim from "./ShowPdfBoletim.vue";
import ShowPdfDocumento from "./ShowPdfDocumento.vue";

export default {
  props: {
    documento: { type: Object },
    dialogCompartilhamento: { type: Boolean }
  },
  components: {
    ShowPdfBoletim,
    ShowPdfDocumento
  },
  data() {
    return {
      dialog: false,
      obj: null,
      visualizado: false,
      url: process.env.VUE_APP_URL_BUSCA,
      darken: true,
      palavrasChave: [],
      referenciasLegislativas: [],
      decisoesRelacionadas: []
    };
  },
  created() {
    this.dialog = this.dialogCompartilhamento;
    this.loadPalavrasChaves();
    this.loadReferenciasLegislativas();
    this.loadDecisoesRelacionadas();
  },
  methods: {
    loadDecisoesRelacionadas() {
      this.decisoesRelacionadas = [];
      this.documento._source.jurisprudencia_decisoes_relacionadas.map(
        decisaoRelacionada => {
          if (decisaoRelacionada.edoc) {
            this.decisoesRelacionadas.push(decisaoRelacionada);
          }
        }
      );
    },
    loadReferenciasLegislativas() {
      this.referenciasLegislativas = [];
      this.documento._source.jurisprudencia_legislacao.map(
        referenciaLegislativa => {
          if (referenciaLegislativa.normativocompleto) {
            this.referenciasLegislativas.push(referenciaLegislativa);
          }
        }
      );
    },
    loadPalavrasChaves() {
      this.palavrasChave = [];
      this.documento._source.jurisprudencia_assunto.map(palavraChave => {
        if (palavraChave.assuntocompleto) {
          this.palavrasChave.push(palavraChave);
        }
      });
    },
    copyLink() {
      const urlPrincipal = process.env.VUE_APP_URL_BUSCA.replace(/#/g, "");
      const link = `${urlPrincipal}#${this.$route.path}?q=${this.documento._source.documento_edoc}&filter[hash]=${this.documento._source.hash}`;
      navigator.clipboard.writeText(link);
      const objeto = {
        text: `Jurisprudência ${this.documento._source.documento_edoc} copiada para área de transferência com sucesso!`,
        color: "success"
      };
      this.$store.commit("SET_SNACK_MESSAGE", objeto);
    },
    visualizarDocumento() {
      this.dialog = !this.dialog;
    },
    colorJurispridencia(situacao) {
      if (situacao == "Descartada") {
        return "deep-orange lighten-3";
      }
      if (situacao == "Pré-Descartada") {
        return "orange lighten-3";
      }
      if (situacao == "Publicada") {
        return "blue darken-1";
      }
      if (situacao == "Capturada") {
        return "blue lighten-3";
      }

      if (situacao == "Em Análise") {
        return "blue lighten-3";
      }
    },
    searchTermo(termo) {
      this.$emit("newSearchTermo", termo);
    },
    searchNormativo(normativo) {
      this.$emit("newSearchNormativo", normativo);
    },
    searchDecisaoRelacionada(edocrelacionado) {
      console.log(edocrelacionado);
      //this.$emit("newSearchDecisao", edoc);
    },
    linkNormativo(link) {
      window.open(link, "_blank");
    }
  }
};
</script>
